<template>
  <div>
    <div
      class="audio-uploader flex-center-vertically text-center"
      style="min-height: 50px; height: auto; border: 1px dashed"
      :style="{
        borderColor: activeColor,
        cursor: readonly ? '' : 'pointer',
        backgroundColor: readonly ? secondary : '',
        width: fullWidth ? '' : `${pw}px`,
        height: fullWidth ? '' : `${ph}px`,
      }"
      ref="dragDropBox"
      @click="chooseAudio"
      @dragover="dragover"
      @dragleave="dragleave"
      @drop="drop"
    >
      <div v-if="!upload && (!audio || !audio.url)">
        <feather-icon
          icon="AudioIcon"
          size="30"
          :style="{
            color: readonly ? '#ffffff' : activeColor,
          }"
        />
        <div
          :style="{
            color: readonly ? '#ffffff' : activeColor,
          }"
        >
          {{ $t("general.clickOrDragDropToUploadAudio") }}
        </div>
      </div>
      <div
        v-else
        :style="{
          width: fullWidth ? '' : `${pw}px`,
          height: fullWidth ? '' : `${ph}px`,
          padding: '5px',
        }"
        class="d-flex justify-content-between"
      >
        <audio
          class="img-fluid"
          controls
          style="max-height: 100%; height: 30px"
        >
          <source
            :src="upload ? upload : audio.url"
            :type="fileType ? fileType : audio.fileType"
          />
          Your browser does not support the audio element.
        </audio>
        <b-button
          size="sm"
          variant="outline-primary"
          class="btn-tour-skip mr-1"
          @click="remove()"
        >
          <span class="mr-25 align-middle">{{ $t("button.remove") }}</span>
          <feather-icon icon="XIcon" size="12" />
        </b-button>
      </div>
    </div>
    <input
      type="file"
      style="display: none"
      name="fields[assetsFieldHandle][]"
      id="assetsFieldHandle"
      class="w-px h-px opacity-0 overflow-hidden absolute"
      @change="onChange"
      ref="fileInput"
      accept=".mp3,.wav,.ogg,.oga,.mogg,.voc,.webm,.mpeg"
    />
  </div>
</template>

<script>
import { $themeConfig } from "@themeConfig";
import { BButton } from "bootstrap-vue";

export default {
  delimiters: ["${", "}"],

  data: function () {
    return {
      filelist: [],
    };
  },

  components: {
    BButton,
  },

  props: {
    audio: {},
    value: {},
    size: {},
    pw: {},
    ph: {},
    fullWidth: {
      type: Boolean,
      default: true,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "audio",
    },
    readonly: {},
  },
  data() {
    return {
      upload: "",
      fileType: "",
    };
  },
  methods: {
    onChange() {
      if (this.readonly) {
        return;
      }

      this.filelist = [...this.$refs.fileInput.files];

      var reader = new FileReader();
      reader.onload = (e) => {
        this.upload = e.target.result;
        this.fileType = this.filelist[0].type;
        this.$emit("input", this.filelist[0]);
        this.$emit("change", e.target.result);
      };
      reader.readAsDataURL(this.filelist[0]);
    },
    remove() {
      if (this.filelist?.length > 0) {
        this.filelist.splice(0, 1);
      }
      this.upload = null;
      this.audio = null;
      this.fileType = null;
      this.$emit("input", null);
      this.$emit("change", null);
    },
    dragover(event) {
      if (this.readonly) {
        return;
      }

      event.preventDefault();
      this.activeColor = this.primary;
    },
    dragleave(event) {
      if (this.readonly) {
        return;
      }
      this.activeColor = this.secondary;
    },
    drop(event) {
      if (this.readonly) {
        return;
      }
      event.preventDefault();
      this.$refs.fileInput.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
    },

    chooseAudio() {
      if (this.readonly) {
        return;
      }
      this.$emit("blur", null);
      this.$refs.fileInput.value = null;
      this.$refs.fileInput.click();
    },
  },
  setup() {
    // App Name
    const { primary, secondary } = $themeConfig.color;

    let activeColor = secondary;

    return {
      primary,
      secondary,
      activeColor,
    };
  },
};
</script>

<style scoped>
.flex-center-vertically {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
</style>
